<template lang="pug">
  include ../../../pug/mixins/bem
  Slick(ref="slick"
    :options="options"
    @afterChange="handleAfterChange"
    @init='handleInit'
    :class='"default-slider"')
    slot(name='slide')
</template>
<script>
import Slick from 'vue-slick'
export default {
  name: 'CustomSlider',
  props: ['options', 'needRefresh', 'goto'],
  components: {
    Slick
  },
  watch: {
    needRefresh() {
      this.$refs.slick.destroy()
      this.$nextTick(() => {
        this.$refs.slick.create()
      })
    },
    goto() {
      this.$refs.slick.goTo(this.index)
    }
  },
  data() {
    return { 
      index: 2
    }
  },
  mounted() {
    if (window.innerWidth > 1199) {
      this.$refs.slick.destroy()
    }
  },
  methods: {
    handleAfterChange(event, slick, currentSlide) {
      this.$emit('changeSlide', currentSlide)
      // console.log('handleAfterChange', event, slick, currentSlide)
    },
    handleInit(event, slick) {
      this.$emit('init', slick)
      // console.log('handleAfterChange', event, slick, currentSlide)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/js/shared/components/CustomSlider.vue